import React from 'react';
import classes from '../../bidAnalysisTemplate.module.scss';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  onHelperClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  required = false,
  error,
  helperText,
  onHelperClick,
  children,
  className = '',
}) => {
  return (
    <div className={`${classes.formField} ${className}`}>
      <label>
        {label} {required && <span className={classes.required}>*</span>}
      </label>
      {children}
      {helperText && (
        <span
          className={classes.helperLink}
          onClick={onHelperClick}
          style={onHelperClick ? { cursor: 'pointer' } : {}}
        >
          <i className="pi pi-external-link"></i> {helperText}
        </span>
      )}
      {error && (
        <span className={classes.validationError}>
          <i className="pi pi-exclamation-circle"></i>
          {error}
        </span>
      )}
    </div>
  );
};

